import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';

import {
	setModoTela, initForm
} from './compraStatusActions';

class CompraStatusForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		
		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>

							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome' placeholder='Informe o nome'
								cols='12 12 12 12'
								readOnly={readOnly} />
								
							<Select
								name='status_possiveis'
								label='Status evoluir e voltar' placeholder='Informe'
								options={this.props.lista.filter(item => item.id != this.props.formularioValues.id).map(item => ({ id: item.id, valor: item.nome }))}
								multiple
								cols='12 12 12 12'
								readOnly={readOnly}
								value={(this.props.formularioValues.status_possiveis || [])}
								onChange={value => {
									this.props.initForm({
										...this.props.formularioValues,
										status_possiveis: (value || []).map(item => parseInt(item.value))
									});
								}} />
							
							<Field
								name='inicial'
								component={LabelAndCheckbox}
								label='Status Inicial' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='final'
								component={LabelAndCheckbox}
								label='Status Final' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />
							
							<Field
								name='backorder'
								component={LabelAndCheckbox}
								label='Status Backorder' placeholder='Informe'
								cols='12 12 12 12'
								readOnly={readOnly} />

						</Row>

					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => window.confirm('Deseja realmente sair dessa tela?') ? this.props.setModoTela('lista') : null} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
    }


}

CompraStatusForm = reduxForm({form: 'compraStatusForm', destroyOnUnmount: false})(CompraStatusForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('compraStatusForm')(state),
	registro: state.compraStatus.registro,
	lista: state.compraStatus.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CompraStatusForm);
